module.exports = __webpack_public_path__ + "static/img/designGuide10.ecb5f6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designGuide10.png
// module id = vJeK
// module chunks = 2